import module from './module';

export default (store) => {
  store.registerModule(['sensors', 'properties'], module());
};
